<div
  [matTooltip]="tooltip"
  class="tooltip-touch"
  matTooltipClass="custom-tooltip"
  #tt="matTooltip"
  (click)="tt.show()"
>
  <i>i</i>
</div>
